import { NgModule } from '@angular/core';

import { ApAutocompleteInputRefDirective } from './autocomplete-panel/autocomplete.directive';
import { ApAutocompleteOptionComponent } from './option/option.component';
import { ApAutocompleteComponent } from './autocomplete-panel/autocomplete-panel.component';
import { ApAutocompleteFilterService } from './autocomplete-filter/autocomplete-filter.service';

@NgModule({
    imports: [ApAutocompleteComponent, ApAutocompleteOptionComponent, ApAutocompleteInputRefDirective],
    exports: [ApAutocompleteComponent, ApAutocompleteOptionComponent, ApAutocompleteInputRefDirective],
    providers: [ApAutocompleteFilterService]
})
export class ApAutocompleteModule {}
